export const useDRM = () => {
	const isWidevineL1 = async (): Promise<boolean> => {
		try {
			await navigator.requestMediaKeySystemAccess("com.widevine.alpha", [
				{
					initDataTypes: ["cenc"],
					videoCapabilities: [
						{
							contentType: 'video/mp4; codecs="avc1.640028"',
							robustness: "HW_SECURE_ALL",
						},
					],
				},
			])
			return true // likely L1
		} catch {
			return false // fallback to L3
		}
	}

	const getWidevineLevel = async (): Promise<"L1" | "L3"> => {
		const configL1 = [
			{
				initDataTypes: ["cenc"],
				videoCapabilities: [
					{
						contentType: 'video/mp4; codecs="avc1.42E01E"',
						robustness: "HW_SECURE_ALL",
					},
				],
			},
		]

		const configPlayReady = [
			{
				initDataTypes: ["cenc"],
				videoCapabilities: [
					{
						contentType: 'video/mp4; codecs="avc1.42E01E"',
					},
				],
			},
		]

		try {
			// Check Windows PlayReady First (High Quality Allowed on Desktop)
			await navigator.requestMediaKeySystemAccess("com.microsoft.playready", configPlayReady)
			// console.log("Detected PlayReady (Windows) -> Serving L1")
			return "L1"
		} catch (e) {
			// Not PlayReady, check Widevine L1
			try {
				await navigator.requestMediaKeySystemAccess("com.widevine.alpha", configL1)
				// console.log("Detected Widevine L1 -> Serving L1")
				return "L1"
			} catch (e) {
				// console.log("L1/PlayReady Failed. Fallback to L3 -> Serving 576p")
				return "L3"
			}
		}
	}

	return {
		isWidevineL1,
		getWidevineLevel,
	}
}
